import React from 'react';
interface CtaButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'dark';
  className?: string;
  href?: string;
  onClick?: () => void;
}
export function CtaButton({
  children,
  variant = 'primary',
  className = '',
  href,
  onClick
}: CtaButtonProps) {
  const base = 'inline-flex min-h-[52px] items-center justify-center gap-2.5 rounded-full px-5 py-4 text-center text-sm font-extrabold uppercase leading-tight tracking-wide sm:px-7 transition-[background-color,transform] duration-150 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-terra focus-visible:ring-offset-2 focus-visible:ring-offset-cream sm:text-base';
  const styles = {
    primary: 'bg-terra text-cream shadow-[0_10px_24px_rgba(169,80,47,0.25)] hover:bg-terra-deep',
    dark: 'bg-cocoa text-cream shadow-[0_10px_24px_rgba(58,41,32,0.25)] hover:bg-cocoa-soft'
  }[variant];
  if (href) {
    return <a href={href} className={`${base} ${styles} ${className}`} data-id="element-20" data-mp="15arfghgn5fn3">
        {children}
      </a>;
  }
  return <button type="button" onClick={onClick} className={`${base} ${styles} ${className}`} data-id="element-21" data-mp="35yh8m1z8z44o">
      {children}
    </button>;
}